import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export const useExternalLink = () => {
  const openExternal = async (url: string) => {
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url });
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return { openExternal };
};

// Standalone function for use outside of React components
export const openExternalUrl = async (url: string) => {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
